import './js/GreenRoom/context';
import DropdownList from './js/GreenRoom/Components/DropdownList';
import tippy from 'tippy.js';
import autosize from 'autosize';
import * as Utils from './js/GreenRoom/utils';
import copyButton from "./js/copyButton.js";

window.addEventListener('resize', () => {
    window.IsMobileDevice = Utils.isMobileDevice();
});

function initializeTabs() {
    var allTabs = document.querySelectorAll('[data-tab]');
    var elligibleTabs = [];
    var groups = {};

    for (var i = 0; i < allTabs.length; i++) {
        var tab = allTabs[i];
        if (!tab) {
            continue;
        }

        var device = tab.dataset.device;
        if (!device || (device == 'mobile' && window.IsMobileDevice) || (device == 'desktop' && !window.IsMobileDevice)) {
            elligibleTabs = [...elligibleTabs, tab];
            groups[tab.dataset.tabGroup] = [...(groups[tab.dataset.tabGroup] || []), tab];
        }
    }

    for (var key in groups) {
        var group = groups[key];
        if (!group) {
            continue;
        }

        for (var i = 0; i < group.length; i++) {
            var tab = group[i];
            if (!tab) {
                continue;
            }

            if (i == 0) {
                tab.dataset.tabSelected = 'true';
                var panel = document.querySelector(`[data-panel="${tab.dataset.tab}"]`);
                if (panel) {
                    panel.classList.remove('hidden');
                }
            }
            else {
                tab.dataset.tabSelected = 'false';
                var panel = document.querySelector(`[data-panel="${tab.dataset.tab}"]`);
                if (panel) {
                    panel.classList.add('hidden');
                }
            }
        }
    }

    elligibleTabs.forEach((tab, index) => {
        tab.addEventListener('click', function (event) {
            var clickedTab = event.target;
            var group = groups[clickedTab.dataset.tabGroup];
            if (group) {
                var selectedTab = group.filter(x => x.dataset.tabSelected == 'true').shift();
                if (selectedTab) {
                    selectedTab.dataset.tabSelected = 'false';
                    var selectedPanel = document.querySelector(`[data-panel="${selectedTab.dataset.tab}"]`);
                    if (selectedPanel) {
                        selectedPanel.classList.add('hidden');
                    }
                }
            }
            clickedTab.dataset.tabSelected = 'true';
            var panel = document.querySelector(`[data-panel="${clickedTab.dataset.tab}"]`);
            if (panel) {
                panel.classList.remove('hidden');
            }
        });
    });
}

window.initTippy = function(element) {
    var content = element.dataset.content;
    if (!content || !content.length) {
        var renderer = element.dataset.renderer;
        if (renderer && renderer.length) {
            try {
                content = eval(`${renderer}.call()`);
            }
            catch (ex) {
                console.error(`Error while evaluate tooltip renderer for ${element.tagName}.${element.classList.join('')}#${element.id}`, ex);
            }
        }
    }
    element.dataset.tooltip = tippy(element, {
        arrow: true,
        content: content,
        ignoreAttributes: true,
        sticky: true,
        theme: 'limelife',
        touch: window.IsMobileDevice,
        touchHold: window.IsMobileDevice,
        trigger: window.IsMobileDevice ? 'click' : undefined,
    });
}

document.addEventListener('DOMContentLoaded', function () {
    try {
        document.querySelectorAll('textarea[autosize]').forEach(textare => {
            textare.addEventListener('focus', function () {
                autosize(textare);
            });
        });
    }
    catch (error) {
        console.error(error);
    }

    try {
        initializeTabs();
    }
    catch (error) {
        console.error(error);
    }

    try {
        if (!window.IsMobileDevice) {
            document.querySelectorAll('select[dropdownlist]').forEach(select => {
                select._dropdownList = new DropdownList(select);
            });
        }

        document.querySelectorAll('[tooltip]').forEach(initTippy);
        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) {
                        return;
                    }
                    if (node.hasAttribute('tooltip')) {
                        initComponent(node);
                    }
                    node.querySelectorAll('[tooltip]').forEach(initTippy);
                });

                if (mutation.type === 'attributes') {
                    if (mutation.target.hasAttribute('tooltip')) {
                        initTippy(mutation.target);
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['tooltip']
        });
    }
    catch (error) {
        console.error(error);
    }
});

window.format = function (value) {
    if (value) {
        var args = arguments;
        value = value.replace(/\{(\d+)\}/g, function (match) {
            var index = parseInt(match.match(/\d+/g)) + 1;
            return args[index];
        });
    }
    return value;
};

window.toCurrency = function (amount, cultureName = 'en-US', currencyIso = 'USD', decimals = 2) {
    let isNegative = false;

    if (amount < 0) {
        amount = amount * -1;
        isNegative = true;
    }

    // Reproduit MidpointRounding.AwayFromZero
    const factor = Math.pow(10, decimals);
    amount = Math.sign(amount) * Math.floor(Math.abs(amount) * factor + 0.5) / factor;

    const formatter = new Intl.NumberFormat(cultureName, {
        style: "currency",
        currency: currencyIso,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });

    let result = formatter.format(amount);

    if (isNegative) {
        return `- ${result}`;
    }

    return result;
};

window.copyButton = copyButton;